import React from "react"
import {
  FaSitemap,
  FaUsers,
  FaRobot,
  FaServer,
  FaShieldAlt,
  FaRocket,
} from "react-icons/fa"

export default [
  {
    id: 1,
    icon: <FaSitemap className="service-icon" />,
    title: "Technical Strategy & Architecture",
    text: `Own architecture end-to-end — multi-cloud platforms, build-vs-buy calls, and roadmaps that survive scale. 5x AWS-certified; designed multi-tenant SaaS and AI platforms from a blank page to production.`,
  },
  {
    id: 2,
    icon: <FaUsers className="service-icon" />,
    title: "Engineering Leadership",
    text: `Build and lead teams that ship. Ran a 30-engineer org as Executive Director, and have been architect & delivery lead on enterprise client platforms — hiring, mentoring, and owning the outcome.`,
  },
  {
    id: 3,
    icon: <FaRobot className="service-icon" />,
    title: "Agentic AI Strategy & Delivery",
    text: `Set AI direction and deliver it — autonomous agents (PDCA, ReAct, MCP), LLM products, and fine-tuning platforms taken from thesis to production, not slideware.`,
  },
  {
    id: 4,
    icon: <FaServer className="service-icon" />,
    title: "Platform & DevOps Foundations",
    text: `The operational core: IaC (Terraform/CDK), CI/CD, multi-region and multi-tenant provisioning, observability and automated rollback — the guardrails that let teams move fast safely.`,
  },
  {
    id: 5,
    icon: <FaShieldAlt className="service-icon" />,
    title: "Security & Compliance Programs",
    text: `Stand up security posture, not point fixes — autonomous offensive-security, SASE/VPN, identity (Auth0), and compliance mapping from Check Point to cloud.`,
  },
  {
    id: 6,
    icon: <FaRocket className="service-icon" />,
    title: "0→1 Product & Founding Engineering",
    text: `Take products from idea to live and operate them. Founder/lead on multiple platforms — fintech marketplaces, AI tooling, security training — full-stack across React, Node, and Python.`,
  },
]
